export default class StorageService {
  public static set(key: string, val: any): void {
    const json = JSON.stringify(val);
    localStorage.setItem(key, json);
  }

  public static get(key: string): any {
    const json = localStorage.getItem(key);
    if (json == "undefined") return undefined;
    try {
      return json ? JSON.parse(json) : undefined;
    } catch (err) {
      console.debug("localStorage error at key: " + key, err);
      this.set(key, "");
      return undefined;
    }
  }
}
